import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { StorySection } from './components/StorySection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ObjectionsSection } from './components/ObjectionsSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <main className="w-full max-w-3xl mx-auto px-4 sm:px-6 py-8" data-id="element-2">
        <HeroSection data-id="element-3" />
        <StorySection data-id="element-4" />
        <ProblemSection data-id="element-5" />
        <SolutionSection data-id="element-6" />
        <ResultsSection data-id="element-7" />
        <TestimonialsSection data-id="element-8" />
        <ObjectionsSection data-id="element-9" />
        <PricingSection data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}